import "./footer.css";
import TransitionBanner from "../transitionBanner/transitionBanner";

function Footer() {
  return (
    <div className="footer-main">
      <TransitionBanner orientation="down" />
      <div className="footer-content">
        <div className="footer-text-container">
          <div className="footer-contactA">📞 Numéro de téléphone :</div>
          <div className="footer-contactB">
            <a href="tel:0621848857">06 21 84 88 57</a>
          </div>
        </div>
        <div className="footer-text-container">
          <div className="footer-contactA">📧 Mail : </div>
          <div className="footer-contactB">
            <a href="mailto:contact@controle-reparation.fr">
              contact@reparation-informatique.fr
            </a>
          </div>
        </div>
        <br />© 2025 Contrôle Réparation. All rights reserved.
      </div>
    </div>
  );
}

export default Footer;
